export default "__VITE_ASSET__BqKTn_z9__"